import { FunctionComponent } from "react";

interface MarqueeBannerProps {
  messageType?: string;
  errorMessage?: string;
  errorLink: string;
  displayedLink: string;
}

const MarqueeBanner: FunctionComponent<MarqueeBannerProps> = ({
  messageType,
  errorMessage,
  errorLink,
  displayedLink,
}) => {
  return (
    <div id="marquee">
      <div className={`marquee-bg bg-${messageType}`}>
        <div className="marquee-elem">
          <h3 className="mb-0">
            {errorMessage}&nbsp;
            <a target="_blank" href={errorLink} rel="noreferrer">
              {displayedLink}
            </a>
          </h3>
          <h3 className="mb-0">
            {errorMessage}&nbsp;
            <a target="_blank" href={errorLink} rel="noreferrer">
              {displayedLink}
            </a>
          </h3>
        </div>
      </div>
    </div>
  );
};

export default MarqueeBanner;
